import { useSearchParams } from "react-router-dom";
import GreetingOccasionCategoryService from "../../../services/GreetingOccasionCategoryService";
import GreetingOccasionSubcategoryService from "../../../services/GreetingOccasionSubcategoryService";
import { GreetingOccasionCategory } from "../../../models";
import { GreetingOccasionCategoryViewModel } from "../../../viewModels";
import { useEffect, useState } from "react";
import { CreateGreetingOccasionCategory } from "./ui/buttons";
import GreetingOccasionCategoriesTable from "./ui/greeting-occasion-categories-table";
import GreetingOccasionCategoriesSkeleton from "./skeleton/greeting-occasion-categories-skeleton";

export default function GreetingOccasionCategoriesPage() {
    const [searchParams] = useSearchParams();
       const api = new GreetingOccasionCategoryService();       
       const [greetingOccasionCategories,setGreetingOccasionCategories] = useState<GreetingOccasionCategoryViewModel[]>([]);
       const [loading, setLoading] = useState(true);

       useEffect(() => {     
         fetchGreetingOccasionCategories();
       }, [searchParams.get("reload")]);
       
       const fetchGreetingOccasionCategories = async () => {
         try {
           const categories = await api.getGreetingOccasionCategories();           
           setGreetingOccasionCategories(categories);
         } catch (error) {
           console.error("Error fetching greeting occasion categories:", error);
         } finally {
           setLoading(false);
         }
       };
        
     return (
       <div className="w-full">
         <div className="flex w-full items-center justify-between">
           <h1 className={` text-2xl`}>Greeting Occasion Categories</h1>
         </div>
         <CreateGreetingOccasionCategory />
         {loading ? <GreetingOccasionCategoriesSkeleton /> : <GreetingOccasionCategoriesTable greetingOccasionCategories={greetingOccasionCategories} />}
       </div>
     );
   
}

